// extracted by mini-css-extract-plugin
export default {"myScore":"MyScore_myScore__2xCfA"};